import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";

// Custom.
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { GET_TUTOR_CERTIFICATES, DELETE_TUTOR_CERTIFICATE } from "api";
import EnhancedTable from "@vocollege/components/dist/EnhancedTable";
import Layout from "containers/Layout/Layout";
import VoAuth from "@vocollege/app/dist/modules/VoAuth";
import { useStyles as useStylesContentList } from "ui/styles/contentList";
import DownloadButton from "components/DownloadButton";
import TutorCertificateTemplate from "containers/Templates/TutorCertificate";
import { getFileName } from "services/Utils";
import GroupTitle from "components/GroupTitle";
import { EnhancedTableFilterValue } from "@vocollege/components/dist/EnhancedTable";
import { GeneralObject } from "@vocollege/app/dist/global";

const TutorCertificates: React.FC = (props) => {
  let navigate = useNavigate();
  const classesContentList = useStylesContentList();
  const [regions, setRegions] = useState<EnhancedTableFilterValue[]>([]);
  const [localColleges, setLocaColleges] = useState<EnhancedTableFilterValue[]>(
    []
  );
  const [educators, setEducators] = useState<EnhancedTableFilterValue[]>([]);

  const editItem = (id = "skapa") => {
    navigate(`/handledarintyg/${id}`);
  };

  const handleDataChange = (data: any) => {
    setRegions([
      { label: I18n.get.actions.showAll, value: "all" },
      { label: I18n.get.misc.noRegion, value: "none" },
      ...data.allGroups
        .filter((v: GeneralObject) => v.category === "region")
        .map((v: GeneralObject) => ({
          label: v.title,
          value: v.id,
        })),
    ]);
    setLocaColleges([
      { label: I18n.get.actions.showAll, value: "all" },
      { label: I18n.get.misc.noRegion, value: "none" },
      ...data.allGroups
        .filter((v: GeneralObject) => v.category === "local")
        .map((v: GeneralObject) => ({
          label: v.title,
          value: v.id,
        })),
    ]);
    setEducators([
      { label: I18n.get.actions.showAll, value: "all" },
      { label: I18n.get.misc.noRegion, value: "none" },
      ...data.allGroups
        .filter((v: GeneralObject) => v.category === "educator")
        .map((v: GeneralObject) => ({
          label: v.title,
          value: v.id,
        })),
    ]);
  };

  const getFilters = () => {
    return [
      {
        name: "region",
        label: I18n.get.group.categories.region,
        default: ["all"],
        multiple: true,
        values: regions,
      },
      {
        name: "local",
        label: I18n.get.group.categories.local,
        default: ["all"],
        multiple: true,
        values: localColleges,
      },
      {
        name: "educator",
        label: I18n.get.group.categories.educator,
        default: ["all"],
        multiple: true,
        values: educators,
      },
    ];
  };
  const getActionButtons = () => {
    let buttons = [];
    if (VoAuth.ability.can("update_own_tutor_certificates", "Cert")) {
      buttons.push("edit");
    }
    if (VoAuth.ability.can("delete_own_tutor_certificates", "Cert")) {
      buttons.push("delete");
    }
    return buttons;
  };

  const getCustomActionButtons = (row: any, index: number) => {
    return (
      <>
        <DownloadButton
          auditResource={{ resourceType: "TutorCertificate", id: String(row.id) }}
          className={clsx(classesContentList.actionButton, {
            "vo-cert-download-from-list": index === 0,
          })}
          document={<TutorCertificateTemplate item={row} />}
          fileName={`${getFileName([
            row && row.firstname,
            row && row.lastname,
          ])}.pdf`}
        />
      </>
    );
  };

  return (
    <>
      <Layout>
        <EnhancedTable
          enableSearch
          className="vo-global__top-bottom-space"
          title={I18n.get.tutorCertificate.labels.tutorCertificates}
          operations={{
            category: "certTutorCertificates",
            get: GET_TUTOR_CERTIFICATES,
            delete: DELETE_TUTOR_CERTIFICATE,
          }}
          labels={{
            deleted: I18n.get.tutorCertificate.messages.tutorCertificateDeleted,
          }}
          columns={[
            { title: "ID", field: "id", width: 90 },
            { title: I18n.get.user.labels.firstname, field: "firstname" },
            { title: I18n.get.user.labels.lastname, field: "lastname" },
            {
              title: I18n.get.group.categories.region,
              field: "region",
              width: 200,
              render: (data) => <GroupTitle item={data?.region} />,
            },

            {
              title: I18n.get.misc.created_at,
              field: "created_at",
              width: 200,
            },
            {
              title: I18n.get.misc.updated_at,
              field: "updated_at",
              width: 200,
            },
          ]}
          addItem={
            VoAuth.ability.can("create_own_tutor_certificates", "Cert")
              ? editItem
              : undefined
          }
          editItem={editItem}
          orderBy="UPDATED_AT"
          order="DESC"
          actionButtons={getActionButtons()}
          renderActionButtons={getCustomActionButtons}
          filters={getFilters()}
          onDataChange={handleDataChange}
        />
      </Layout>
    </>
  );
};

export default TutorCertificates;
